import { createContext } from "react";

export type ResponsiveSheetContextValue = {
  isSidePanel: boolean;
  setOpen: (open: boolean) => void;
};

export const ResponsiveSheetContext =
  createContext<ResponsiveSheetContextValue>({
    isSidePanel: false,
    setOpen: () => {},
  });
